import React from 'react';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { withFormik } from 'formik';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import Typography from '@material-ui/core/Typography';
import * as yup from 'yup';
import axiosWithoutInterceptor from 'axios';

import Input from '../Input/Input';
import PaypalButtons from '../PaypalButtons/PaypalButtons';
import { cpfMask, phoneMask, cepMask } from '../../shared/masks';
import { usageLog } from '../../store/actions/globalActions';

const PaymentForm = (props) => {
  const {
    values,
    handleSubmit,
    handleChange,
    errors,
    touched,
    handleBlur,
    isLegalEntity,
    onChangeValue,
    onConfirmPayment,
    loading,
  } = props;

  const fields = [
    {
      elementType: 'input',
      config: {
        name: 'name',
        label: !isLegalEntity ? 'Nome' : 'Razão Social',
        // required: true,
      },
    },
    {
      elementType: 'maskedInput',
      config: {
        name: 'document',
        label: !isLegalEntity ? 'CPF' : 'CNPJ',
        mask: !isLegalEntity ? cpfMask : [
          /\d/,
          /\d/,
          '.',
          /\d/,
          /\d/,
          /\d/,
          '.',
          /\d/,
          /\d/,
          /\d/,
          '/',
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          '-',
          /\d/,
          /\d/,
        ],
        // required: true,
      },
    },
    {
      elementType: 'maskedInput',
      config: {
        name: 'phone',
        label: 'Telefone',
        // required: true,
        mask: phoneMask,
      },
    },
    {
      elementType: 'input',
      config: {
        name: 'email',
        label: 'E-mail',
        // required: true,
      },
    },
    {
      elementType: 'maskedInput',
      config: {
        name: 'zipCode',
        label: 'CEP',
        // required: true,
        mask: cepMask,
      },
      helperText: 'Pesquise o endereço pelo CEP',
    },
    {
      elementType: 'input',
      config: {
        name: 'address',
        label: 'Endereço',
        // disabled: true,
      },
    },
    {
      elementType: 'input',
      config: {
        name: 'addressNumber',
        label: 'Número',
        // required: true,
      },
    },
    {
      elementType: 'input',
      config: {
        name: 'complement',
        label: 'Complemento',
        // required: true,
      },
    },
    {
      elementType: 'input',
      config: {
        name: 'district',
        label: 'Bairro',
        // disabled: true,
      },
    },
    {
      elementType: 'input',
      config: {
        name: 'city',
        label: 'Cidade',
        // disabled: true,
      },
    },
    {
      elementType: 'input',
      config: {
        name: 'state',
        label: 'Estado',
        // disabled: true,
      },
    },
  ];

  const { validateForm } = props;

  const fetchCEP = (rawCEP) => {
    const cep = rawCEP.replace(/\D+/g, '');

    axiosWithoutInterceptor
      .get(`https://viacep.com.br/ws/${cep}/json/`)
      .then((response) => {
        if (response.data && response.data.erro) {
          props.setValues({
            ...values,
            zipCode: rawCEP,
            address: '',
            district: '',
            city: '',
            state: '',
            cityCod: '',
          });
        } else {
          props.setValues({
            ...values,
            zipCode: rawCEP,
            address: response.data.logradouro,
            district: response.data.bairro,
            city: response.data.localidade,
            state: response.data.uf,
            cityCod: response.data.ibge,
          });
        }
      });
  };

  const fetchCurrentCEP = () => {
    if (values.zipCode.length === 9) {
      fetchCEP(values.zipCode);
    }
  };

  React.useEffect(fetchCurrentCEP, []);

  React.useEffect(() => {
    validateForm();
  }, [validateForm]);

  const companyId = JSON.parse(localStorage.getItem('companies')).find(x => x.companyId).companyId;
  const userId = JSON.parse(localStorage.getItem('companies')).find(x => x.userId).userId;

  return (
    <div>
      <FormControlLabel
        control={
          <Radio
            color="primary"
            checked={isLegalEntity}
            onChange={() => onChangeValue('isLegalEntity', true)}
            value={isLegalEntity}
            icon={<RadioButtonUncheckedIcon fontSize="small" />}
            checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
          />
        }
        label="Pessoa jurídica"
      />
      <FormControlLabel
        control={
          <Radio
            color="primary"
            checked={!isLegalEntity}
            onChange={() => onChangeValue('isLegalEntity', false)}
            value={isLegalEntity}
            icon={<RadioButtonUncheckedIcon fontSize="small" />}
            checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
          />
        }
        label="Pessoa física"
      />
      <form onSubmit={handleSubmit}>
        <Grid container>
          {
            fields.map(field => (
              <Grid item xs={6} style={{ paddingTop: '16px' }}>
                <Input
                  {...field.config}
                  elementType={field.elementType}
                  value={values[field.config.name]}
                  onChange={(event) => {
                    handleChange(event);
                    if (event.target.name === 'zipCode' && event.target.value.replace(/\D+/g, '').length === 8) {
                      fetchCEP(event.target.value);
                    }
                    if (errors && Object.keys(errors).length == 1 || 0) {
                      usageLog("Assinaturas/comprar/premium/modalFaturamento", companyId, userId, values);
                    }
                  }}
                  onBlur={(event) => {
                    onChangeValue('values', values);
                    handleBlur(event);
                  }}
                  error={errors[field.config.name] && touched[field.config.name]}
                  helperText={
                    (touched[field.config.name] && errors[field.config.name]) || field.helperText
                  }
                  style={{ width: '90%' }}
                />
              </Grid>
            ))
          }
        </Grid>
        {
          errors && Object.keys(errors).length === 0 && (
            <div style={{ marginTop: '30px' }}>
              <Typography>
                Selecione a forma de pagamento para finalizar a compra
              </Typography>
              <PaypalButtons
                plan={props.plan}
                planType={props.planType}
                values={values}
                loading={loading}
                onConfirmPayment={onConfirmPayment}
                onChangeValue={onChangeValue}
              />
            </div>
          )
        }
      </form>
    </div>
  );
};

const PaymentFormFormik = withFormik({
  mapPropsToValues: ({ values }) => ({
    name: values.name || '',
    document: values.document || '',
    phone: values.phone || '',
    email: values.email || '',
    zipCode: values.zipCode || '',
    address: values.address || '',
    addressNumber: values.addressNumber || '',
    complement: values.complement || '',
    district: values.district || '',
    city: values.city || '',
    state: values.state || '',
  }),
  validationSchema: yup.object().shape({
    name: yup.string().required(),
    document: yup.string().required(),
    phone: yup.string().strict(false).trim('Informe um formato válido').required(),
    email: yup.string().email().required(),
    zipCode: yup.string().required(),
    address: yup.string().required(),
    addressNumber: yup.string().required(),
    complement: yup.string().required(),
    district: yup.string().required(),
    city: yup.string().required(),
    state: yup.string().required(),

  }),
})(PaymentForm);

export default PaymentFormFormik;
